import { ref } from 'vue';
import type { Locale } from './useLocale';

/**
 * アプリケーション全体で共有されるロケール状態
 * sharedレイヤーに配置することで、pages/_layoutやfeaturesから参照可能
 */
export const globalLocale = ref<Locale>('en');
